export default __webpack_public_path__ + "static/media/ig-icon.1b0f1d21.svg";